export enum Period {
  raw = "raw",
  twoMinutes = "two-minutes",
  hourly = "hour",
  daily = "day",
  monthly = "month"
}